// Add VRP pricing hover feature.
(function($) {
  jQuery(document).ready(function($) {
    isVRP = {
      any: function() {
          return $('#results-page').length ? true : false;
      }
    };
  
    isVDP = {
      hotwheels: function() {
          return $('.project-hotwheels').length ? true : false;
      }
    };

    if(isVRP.any()){
      jQuery("body").on("vrp-ready vrp-ajax-complete",function(){
        enableHover();
      });
    }
    if(isVDP.hotwheels()){  
      enableHover();
    }
  });

  function enableHover(){ 
    var getClasses;
    var classesArr;
    var individualClassBreakDown;
    var getHoverUniqueEle;
    var hoverContainerText;
    var hoverBtnIndicator;
    var hoverEleArr = [];
    var hoverContainer;

    // checks to see if the hover classes exist
    if ($('div[class*="hover-button-"]').length > 0) {
      
        // grabs all the elements that have the hover class
        $('div[class*="hover-button-"]').each(function() {

          getClasses = $(this).attr('class');
          classesArr = getClasses.split(' ');

          //loops through the classes
          for (var i = 0; i < classesArr.length; i++) {

            // if the class has hover-button- then we get to work
            if(classesArr[i].indexOf('hover-button-') !== -1 ){

              hoverBtnIndicator = '.' + classesArr[i];
              individualClassBreakDown = classesArr[i].split('-');
              getHoverUniqueEle = individualClassBreakDown[2];
              hoverContainerText = '.hover-container-' + getHoverUniqueEle;
              hoverContainer = isVRP.any() ? $(this).closest('.price-top').find(hoverContainerText) : hoverContainerText;
              
              // check to see if the class is the hover one, makes sure that class is not in the array already and the partner container exists
              if ( (hoverEleArr.indexOf(hoverBtnIndicator) !== -1 ) === false && $(hoverContainer).length > 0) {
                hoverEleArr.push(hoverBtnIndicator);
                if(isVDP.hotwheels()){
                  $(hoverBtnIndicator).vdpTextHover({    
                    existingContent: $(hoverContainerText),   
                  });
                }else{
                  $(hoverBtnIndicator).vrpTextHover({  
                    existingContent: $(hoverContainerText), 
                  });
                }
              }
            }
          }
        });
    }
  }

  $.fn.vrpTextHover = function(params) {
    var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    var hoverBtn = $(this);
    var hoverText = params.text;
    var getContentClass = params.existingContent;
    var createHoverBox;
    var mobileToggle = "<span class='expand-toggle'><i>Expand</i></span>";
    var hoverContentWrapper = "<div class='hover-content-wrapper "+id+"'>"+ mobileToggle+"</div>";
    var hasContent = (getContentClass === "" || typeof getContentClass == 'undefined') ? false : true;
    var target = ".vrp-hover-content, .hover-pricing-content";

      /*
      *  if text is provided and no existing container object
      */
      if(hoverText && !hasContent){
          createHoverBox = "<div class='vrp-hover-content hover-content-wrapper'>"+ mobileToggle + hoverText + "</div>";
      }

      if(hasContent && !hoverText){
          //set the target divs to be the ones provided
          target = getContentClass;
       }
      $("#results-page .vehicle").each(function(i,vehicle){
        $(vehicle).find(hoverBtn).addClass("hover-btn");
        var vrpBox = $(vehicle).find(target);
        if(createHoverBox){
          $(createHoverBox).insertAfter($(vehicle).find(hoverBtn));
        }
        else{
          $(hoverContentWrapper).insertAfter($(vehicle).find($(hoverBtn)) );
          var hoverWrapperId = ".hover-content-wrapper."+id;
          $.each(vrpBox,function(j,element){
            $(element).appendTo($(vehicle).find( hoverWrapperId ));
          });
        }
      });
    return params;
  };
  $.fn.vdpTextHover = function(params) {
    var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    var hoverBtn = $(this);
    var hoverText = params.text;
    var getContentClass = params.existingContent;
    var createHoverBox;
    var mobileToggle = "<span class='expand-toggle'><i>Expand</i></span>";
    var hoverContentWrapper = "<div class='hover-content-wrapper "+id+"'>"+ mobileToggle+"</div>";
    var vdpBox = $(".vdp-hover-content, .hover-pricing-content");

    if( $("body").hasClass("page-vehicle-display-page")){
      //create the container if nothing is provided
      if(hoverText && !getContentClass){
        createHoverBox = "<div class='hover-content-wrapper'>"+ mobileToggle + hoverText + "</div>";
      }
      // add a custom selector to the list of default selectors
      if(getContentClass && !hoverText){
        vdpBox = $().add(vdpBox).add(getContentClass);
      }
      $(hoverBtn).addClass("hover-btn");
      //move hover item container below hover price
      if(hoverText){
        $(createHoverBox).insertAfter(hoverBtn);
        $(hoverBtn).popover({
          placement: 'left',
          html: true,
          content: function () {
              return $(createHoverBox)[0].outerHTML;
          },
          trigger: 'hover'
        })
      }
      else{
        //move hover item container below hover price
        $(hoverContentWrapper).insertAfter(hoverBtn);
        // loop through list of selectors to be placed in the hover item stack
        var hoverWrapperId = ".hover-content-wrapper."+id;
        $.each(vdpBox,function(j,element){
          $(element).appendTo($('.advanced-pricing-stack').find($(hoverWrapperId)));
        });


        if( $(".vdp--lightning").length ){
          $(hoverBtn).popover({
            placement: 'bottom',
            html: true,
            content: function () {
                return $(hoverWrapperId)[0].outerHTML;
            },
            trigger: 'hover'
          })          
        }
        else{
          $(hoverBtn).popover({
            placement: 'left',
            html: true,
            content: function () {
                return $(hoverWrapperId)[0].outerHTML;
            },
            trigger: 'hover'
          })
        }

      }
    }
  return params;
  };

  
  if( $("body").hasClass("page-vehicle-display-page") || $("body").hasClass("page-vehicle-results-page") ){
    $(document).on("click",".expand-toggle",function(e){
      $(this).closest(".hover-content-wrapper").toggleClass("open");
    });
  }
}(jQuery));